import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { EyeIcon, ShieldIcon, HeartHandshakeIcon } from 'lucide-react';
export function MethodSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const pillars = [{
    icon: EyeIcon,
    title: 'Reconocer',
    description: 'Identifica los nudos y bloqueos ancestrales en tu árbol genealógico'
  }, {
    icon: ShieldIcon,
    title: 'Excluir',
    description: 'Devuelve las cargas que no te pertenecen y recupera tu lugar como hija'
  }, {
    icon: HeartHandshakeIcon,
    title: 'Abrazar',
    description: 'Abre el espacio para recibir la vida con orden y fe dirigida'
  }];
  return <section ref={ref} className="w-full bg-cream py-6 md:py-10 px-6" data-id="element-64">
      <div className="max-w-5xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-66">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brown mb-4 text-center" data-id="element-67">
            El Mecanismo Único
          </h2>

          <div className="bg-white/60 backdrop-blur-sm rounded-3xl p-6 md:p-10 mb-8 border border-gold/20" data-id="element-68">
            <h3 className="font-serif text-2xl font-semibold text-gold mb-4 text-center" data-id="element-69">
              El Método R.E.A. (Reconocer, Excluir, Abrazar)
            </h3>
            <p className="font-sans text-lg text-brown/90 leading-relaxed mb-3" data-id="element-70">
              Este no es un libro de medicina ni de consejos genéricos. Es una
              guía de Reordenamiento Sistémico. A través de la reconciliación
              con tu árbol genealógico y la fe dirigida, aprenderás a devolver
              las cargas que no te pertenecen.
            </p>
            <p className="font-sans text-lg text-brown/90 leading-relaxed font-medium" data-id="element-71">
              Cuando dejas de mirar hacia los traumas del pasado y recuperas tu
              lugar como "hija" en tu linaje, el flujo de la vida finalmente
              puede pasar a través de ti hacia tu futuro hijo.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-72">
            {pillars.map((pillar, index) => {
            const Icon = pillar.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              duration: 0.6,
              delay: index * 0.15
            }} className="bg-white rounded-2xl p-6 text-center shadow-sm border border-rose/10" data-id="element-73">
                  <div className="flex justify-center mb-3" data-id="element-74">
                    <Icon className="w-12 h-12 text-rose" strokeWidth={1.5} data-id="element-75" />
                  </div>
                  <h4 className="font-serif text-2xl font-bold text-brown mb-2" data-id="element-76">
                    {pillar.title}
                  </h4>
                  <p className="font-sans text-base text-brown/80 leading-relaxed" data-id="element-77">
                    {pillar.description}
                  </p>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}